
// this is a type for items that the player could use in the game
type TBaseItem = {
    Id: number; // a unique identifier for the item
    Name: string; // the name of the item
    Description: string; // a description of the item
    Type: EItemType; // the type of the item
}

export enum EItemType {
    Pistol = 'Pistol',
    Rifle = 'Rifle',
    Ammo = 'Ammo',
}

export type TInventoryItem = {
    Id: number; // a unique identifier for the item
    Quantity: number; // the number of items in the inventory
}

// this is a type for items that the player could use in the game
export type TGameItem = TBaseItem | TWeapon | TAmmo;

type TWeapon = TBaseItem & {
    Type: EItemType.Pistol | EItemType.Rifle; // the type of the weapon
    Damage: number; // the base amount of damage the weapon does
    Caliber: string; // the caliber of the weapon
}

type TAmmo = TBaseItem & {
    Caliber: string; // the caliber of the ammo
}


